import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DropdownOption from "./DropdownOption";

const CLASS_FOCUSED = "is-focused";
const CLASS_OPENED = "is-opened";
const CLASS_SELECT_SIMPLE = "is-select-simple";

const optionPropType = PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string
});

class Dropdown extends Component {
    static propTypes = {
        defaultOption: optionPropType,
        options: PropTypes.arrayOf(optionPropType),
        value: optionPropType,
        onChange: PropTypes.func,
        simple: PropTypes.bool
    };

    state = {
        isOpen: false,
        isFocused: false
    };

    handleChange = event => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(event.target.value);

            this.setState({ isOpen: false, isFocused: false });
        }
    };

    handleClick = () => {
        this.setState({ isOpen: true });
    };

    handleClickItem = value => {
        const { onChange } = this.props;
        if (onChange) {
            onChange(value);
        }
        this.setState({ isOpen: false, isFocused: false });
    };

    handleFocus = () => {
        this.setState({ isFocused: true });
    };

    handleBlur = () => {
        this.setState({ isOpen: false, isFocused: false });
    };

    renderOption = ({ key, label, value }) => {
        const { value: current, defaultOption } = this.props;
        const selected =
            (current ? current.value : defaultOption.value) === value;
        return (
            <DropdownOption
                key={key}
                label={label}
                value={value}
                selected={selected}
                onClick={this.handleClickItem}
            />
        );
    };

    render() {
        const { defaultOption, options, simple } = this.props;
        const { isOpen, isFocused } = this.state;
        let { value } = this.props;

        if (!value) {
            value = defaultOption;
        }

        return (
            <div
                className={classNames("dropdown", {
                    [CLASS_FOCUSED]: isFocused,
                    [CLASS_SELECT_SIMPLE]: simple
                })}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                tabIndex={0}
            >
                <select
                    value={value.value}
                    onChange={this.handleChange}
                    tabIndex={-1}
                >
                    {defaultOption && (
                        <option value={defaultOption.value}>
                            {defaultOption.label}
                        </option>
                    )}
                    {options.map(option => (
                        <option key={option.key} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className="dropdown__text" onClick={this.handleClick}>
                    <div className="dropdown__text-inner">{value.label}</div>
                </div>
                {!simple && (
                    <ul
                        className={classNames({
                            [CLASS_OPENED]: isOpen
                        })}
                    >
                        {this.renderOption(defaultOption)}
                        {options.map(this.renderOption)}
                    </ul>
                )}
            </div>
        );
    }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/Dropdown.js